export const DOWNLOAD_TEMPLATE_INTENT = 'download-template'

export const DEFAULT_PDF_NAME = 'expense-policy-template.pdf'
